// Backend AMOUNT_TYPE enum shared by promotions and the SO / SI / PO / PI
// document headers (discount_type + discount_amount + read-only total_discount).
export const DiscountTypeEnum = Object.freeze({
  PERCENTAGE: "PERCENTAGE",
  FIXED_AMOUNT: "FIXED_AMOUNT",
});

export const discountTypeLabels = Object.freeze({
  [DiscountTypeEnum.PERCENTAGE]: "Persentase",
  [DiscountTypeEnum.FIXED_AMOUNT]: "Nominal Tetap",
});
